// Reactive auth session for the Context header. `session` drives the account
// UI; refreshSession() validates the stored token on boot (no-ops signed out).

import { signal } from "@preact/signals";
import { clearSession, getMe, getSession, type Session } from "../api/auth";

export const session = signal<Session | null>(getSession());

export async function refreshSession(): Promise<void> {
  const local = getSession();
  if (!local) {
    session.value = null;
    return;
  }
  const me = await getMe(); // clears storage on 401
  session.value = me ? getSession() : null;
}

export function signOut(): void {
  clearSession();
  session.value = null;
}
